import React, { useState, useEffect, useContext } from "react";
import TopBar from "./components/TopBar";
import Sidebar from "./components/Sidebar";
import { useIdleTimer } from "react-idle-timer";
import "mapbox-gl/dist/mapbox-gl.css";

import "./css/styles.css";

// import OnlineReport from "./pages/OnlineReport";
// import OnlineStats from "./pages/OnlineStats";
import useInterval from "@rooks/use-interval";
// import axios from "axios";

import { ConfigContext } from "./contexts/ConfigContext";
import clsx from "clsx";
import { Outlet, useLocation } from "react-router-dom";
import useAuth from "./hooks/authenticate/useAuth";
// import Toast from "./components/Toast";
// import useNotification from "./hooks/useNotification";
// import SearchBar from "./components/SearchBar";

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }
const Layout = () => {
  const { config } = useContext(ConfigContext);
  const { auth } = useAuth();
  // const { notifications } = useNotification();

  const [pageTitle, setPageTitle] = useState("Login");
  // const [notificationsCount, setNotificationsCount] = useState(0);
  // const [toastNotificationsList, setToastNotificationsList] = useState([]);

  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [keepSideBarOpen, setKeepSideBarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState();
  let stillInside = false;
  // let toastProperties = null;

  let location = useLocation();

  // Get the up-to-date data for the map events every 1 sec
  useInterval(
    () => {
      if (config["token"]) {
        // console.log(config.token);
        // updateEvents();
      }
      // dispatch({ type: "UPDATE_NOTIFICATION", notifications: rest_eventObj.length });
    },
    1000,
    true
  );

  useEffect(() => {
    let path = location.pathname;
    switch (path) {
      case "/":
        setPageTitle("Statistics");
        break;
      case "/login":
        setPageTitle("Login");
        break;
      case "/reports":
        setPageTitle("Reports");
        break;
      case "/home":
        setPageTitle("Dashboard");
        break;
      case "/system-health":
        setPageTitle("System Health");
        break;
      default:
        setPageTitle("--");
        break;
    }
  }, [location]); // eslint-disable-line

  useEffect(()=>{

    const checkMobile = () => {
      if(window.innerWidth < 700){
        setIsMobile(true);
      }else{
       setIsMobile(false); 
      }
    }

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    }
  },[])

  const handleOnIdle = (event) => {
    window.location.reload();
  };

  // Reload page after user is idle
  useIdleTimer({
    timeout: 1000 * 60 * 60,
    onIdle: handleOnIdle,
  });

  return (
    <div className="flex flex-row h-screen">
      {auth?.token && (
        <div
          className={clsx(
            "bg-gray-900 flex-none transition-width",
            { "w-48": sideBarOpen === true },
            { "w-16": sideBarOpen === false },
            {"w-full": isMobile && sideBarOpen},
            {"hidden": isMobile && sideBarOpen === false}
          )}
          onMouseEnter={() => {
            stillInside = true;
            setTimeout(() => {
              if (stillInside) {
                setSideBarOpen(true);
              }
            }, 400);
          }}
          onMouseLeave={() => {
            stillInside = false;
            if (!keepSideBarOpen) {
              setSideBarOpen(false);
            }
          }}
        >
          {config["name"] && (
            <Sidebar
              sideBarOpen={sideBarOpen}
              sideBarToggle={setKeepSideBarOpen}
              keepOpen={keepSideBarOpen}
              setSideBarOpen={setSideBarOpen}
              isMobile={isMobile}
            />
          )}
        </div>
      )}
      <div className="flex flex-col flex-initial relative w-full h-full overflow-y-auto overflow-x-hidden">
        {auth?.token && (
          <div className="sticky top-0 z-30 px-4 pt-2 pb-1 bg-slate-100/90 backdrop-blur-xs">
            <TopBar
              pageTitle={pageTitle}
              logo={config.logo}
              AreaName={config.name}
              sideBarOpen={sideBarOpen}
              setSideBarOpen={setSideBarOpen}
              isMobile={isMobile}
            />
          </div>
        )}
        {/* {auth?.token && <SearchBar />} */}
        <div className="h-full ">
          <Outlet />
          {/* {auth?.token && (
            <Toast
              toastList={toastNotificationsList}
              autoDelete={true}
              autoDeleteTime={5000}
            />
          )} */}
        </div>
      </div>
    </div>
  );
};
export default Layout;
